<template>
  <div class="page-content">
    <div class="box-text-content-title">
      <h2>Bonjour, {{ user.name }}</h2>
      <p>
        <strong
          >Vos renseignements personnels et vos préférences peuvent être
          modifiés en tout temps.</strong
        >
      </p>
    </div>
    <div class="menu-box-home">
      <span class="title-box-menu">Menu</span>
      <div class="container-menu">
        <a
          class="decouvrir-button"
          href="https://www.voyages-lambert.com/nos-nouveautes/"
        >
          <div class="title-decouvrir-button">
            <img src="../assets/compass.svg" />
            À découvrir
          </div>
          <div class="circuit-apercu-title">
            <h4>NOS NOUVEAUTÉS</h4>
            <p>
              Conçus avec l'objectif de vous faire vivre l'émotion culturelle
              sans modération, explorez vos nouveaux itinéraires.
            </p>
          </div>
          <div class="circuit-apercu" :style="HomeImage"></div>
        </a>
        <a class="menu-button-home" @click="toClient"
          ><img src="../assets/profil.svg" />Profils voyageurs</a
        >
        <a class="menu-button-home" @click="toVoyage"
          ><img src="../assets/suitcase.svg" />Mes réservations</a
        >
        <a class="menu-button-home" @click="toHistorique"
          ><img src="../assets/book.svg" />Mon historique de voyages</a
        >
        <a class="menu-button-home" @click="toFavori"
          ><img src="../assets/heart.svg" />Mes favoris</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Menu",
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      param: (state) => state.param.param,
    }),
    HomeImage() {
      return {
        backgroundImage: `url(${require("../assets/Arizona_The_Wave_iStock-960419974.jpg")})`,
      };
    },
  },
  methods: {
    ...mapActions(["getParam"]),
    toVoyage() {
      this.$router.push({
        name: "TripList",
      });
    },
    toClient() {
      this.$router.push({
        name: "Client",
      });
    },
    toHistorique() {
      this.$router.push({
        name: "historique",
      });
    },
    toFavori() {
      this.$router.push({
        name: "favoriteList",
      });
    },
  },
  created() {
    //do something after creating vue instance
    this.getParam();
  },
};
</script>
<style scoped>
.menu-button-home:hover {
  -webkit-transform: scale(1.2);
  transform: scale(1.2);
  text-decoration: none;
  color: #7b7c7e;
}
.decouvrir-button:hover {
  -webkit-transform: scale(1.2);
  transform: scale(1.2);
  text-decoration: none;
  color: black;
}
</style>
